export var toTitleInfo = function (title) { return ({
    author: title.firstContributor,
    isbn: title.isbn,
    publisher: title.publisher,
    publicationYear: title.publicationYear,
    editionStatement: title.editionStatement,
    bindingText: title.bindingText,
    createdAt: title.createdAt,
    variantTitles: title.variantTitles,
}); };
